document.addEventListener('DOMContentLoaded', function () {

    // Validate PDP structure
    const pdpInfo = document.querySelector('.pdp-detailed-info');

    if (!pdpInfo) {
        return;
    }

    const productPrice = pdpInfo.querySelector('product-price');
    const wrapWithPrice = pdpInfo.querySelector('.wrap-with-price');

    // Ensure both elements exist
    if (productPrice && wrapWithPrice) {

        // Prevent duplicate wrapping
        if (!productPrice.parentElement.classList.contains('price-wrapper')) {

            const wrapper = document.createElement('div');
            wrapper.className = 'price-wrapper';

            // Insert wrapper before first element
            productPrice.parentNode.insertBefore(wrapper, productPrice);

            // Move both elements inside wrapper
            wrapper.appendChild(productPrice);
            wrapper.appendChild(wrapWithPrice);
        }
    }

    document.addEventListener('DOMContentLoaded', () => {
        document.querySelectorAll('.wishlist-engine').forEach(el => {
            el.setAttribute('tabindex', '1');
        });
    });
});